module.exports = "<input type=\"text\"\n       ng-model=\"fakeVM.value\"\n       ng-blur=\"applyNewValue()\"/>"